import queryString from 'query-string';
import { Component, Mixins } from 'vue-property-decorator';
import PrivilegeMixin from './PrivilegeMixin';
import RoundButton from '@/components/RoundButton.vue';
import RoundButtonMenu from '@/components/RoundButtonMenu.vue';
import DetailField from '@/components/DetailField.vue';
import AutoCompleteField from '@/components/AutoCompleteField.vue';
import formatting from '@/formatting';
import { Option } from '../interfaces';
import { api } from '../api';
import { DetailLayoutITF, ReportFileTableITF } from '@/interfaces';

@Component({
  components: { RoundButton, RoundButtonMenu, DetailField, AutoCompleteField }
})
export default class CommonMixin extends Mixins(PrivilegeMixin) {
  public api = api;
  public queryString = queryString;
  public formatting = formatting;

  public async save(rec, apiUrl, endpoint = 'file') {
    const ref: any = this.$refs.layout;
    if (ref.isNew) {
      const response = await this.api.createRecord(this.$store, apiUrl, rec);
      if (response) {
        ref.rec = response.data;
        await this.uploadFiles(ref.rec.id, apiUrl, endpoint);
        this.updateRecord(ref, ref.rec.id, apiUrl);
        this.$router.push(ref.url + '/' + ref.rec.id);
      }
    } else {
      const response = await this.api.updateRecord(
        this.$store,
        apiUrl + rec.id,
        rec
      );
      await this.uploadFiles(rec.id, apiUrl, endpoint);
      this.updateRecord(ref, rec.id, apiUrl);
      this.$router.push(ref.url + '/' + rec.id);
    }
  }

  public async saveWithFiles(apiUrl) {
    const ref: any = this.$refs.layout;
    if (ref.isNew) {
      const response = await this.api.createRecord(
        this.$store,
        apiUrl,
        ref.rec
      );
      if (response) {
        ref.rec = response.data;
        const filesRef: any = this.$refs.files;
        await (filesRef as ReportFileTableITF).saveAllFiles(ref.rec.id);
        this.$router.push(ref.url + '/' + ref.rec.id);
      }
    } else {
      (ref as DetailLayoutITF).commitRecord(ref.rec);
    }
  }

  public async updateRecord(ref, id, apiUrl) {
    const recordResponse = await this.api.getRecord(this.$store, apiUrl + id);
    if (recordResponse) {
      ref.rec = recordResponse.data;
      ref.theForm.resetValidation();
    }
    ref.loading = false;
  }

  public async uploadFiles(id, apiUrl, endpoint) {
    // console.log('CommonMixin.uploadFiles', id, apiUrl, endpoint);
    const ref: any = this.$refs.upload;
    if (ref) {
      // Only execute when at least 1 file is selected
      if (ref.files.length > 0) {
        ref.errorMessages = '';
        const formData = new FormData();
        for (const x of Object.keys(ref.files)) {
          const file: Blob = ref.files[x];
          formData.append('file', file);
        }
        const response = await this.api.uploadFile(
          this.$store,
          apiUrl + id + '/' + endpoint,
          formData
        );
        ref.files = [];
      }
    }
  }

  public buildOptionList(list) {
    if (list) {
      const optionList: Option[] = [];
      for (let i = 0; i < list.length; i++) {
        optionList.push({ value: i, text: list[i] });
      }
      return optionList;
    }
  }
  public getDataType(fieldrec) {
    if (fieldrec.name === 'GPS_1' || fieldrec.name === 'GPS_2') { return 'gps'; }

    // console.log(fieldrec.name, fieldrec.datatype_name);
    if (fieldrec.datatype_name === 'boolean') {
      return 'integer-boolean';
    } else if (fieldrec.datatype_name === 'number') {
      return 'number';
    } else if (fieldrec.datatype_name === 'choice') {
      return 'optionlist';
    } else if (fieldrec.datatype_name === 'date') {
      return 'custom-date';
    } else if (fieldrec.datatype_name === 'gps') {
      return 'gps';
    } else if (fieldrec.datatype_name === 'string') {
      return 'text';
    } else {
      console.log('getDataType: unkown datatype', fieldrec.datatype_name);
      return 'text';
    }
  }
  public getField(type) {
    if (this.getDataType(type) === 'optionlist') {
      return 'value_index';
    } else {
      return 'value';
    }
  }

  public openGoogleMapsRoute(coordSrc, coordDst) {
    if (coordSrc && coordDst) {
      let link = 'https://www.google.com/maps/dir/?api=1';
      link += '&origin=' + coordSrc.lat + ',' + coordSrc.lon;
      link += '&destination=' + coordDst.lat + ',' + coordDst.lon;
      window.open(link, '_blank');
    }
  }

  public duplicateRecord = async function duplicateRecord(store, router, apiUrl, newProps, clientURL) {
    const response = await api.duplicateRecord(store, apiUrl, newProps);
    if (response) {
      router.push(clientURL + '/' + response.data.id);
    }
  };

  public getTableCfg(tableCfg, key, context = this) {
    if (typeof tableCfg[key] === 'function') {
      return tableCfg[key](context);
    } else {
      return tableCfg[key];
    }
  }

  public getPrivilege(tableCfg, context = this) {
    const priv = this.getTableCfg(tableCfg, 'priv');
    if (!priv) {
      console.log('No priv key defined for', tableCfg.overviewTitle);
    }
    return priv;
  }

    public otpStatusText = function otpStatusText(value) {
    if (value === 'Off') {
      return 'Uit';
    } else if (value === 'WaitForSetup') {
      return 'Klaar voor instellen';
    } else if (value === 'On') {
      return 'Aan';
    } else if (value === 'Expired') {
      return 'Verlopen';
    } else {
      return '';
    }
  };

  public otpStatusColor = function otpStatusColor(value) {
    if (value === 'Off') {
      return 'grey lighten-2';
    } else if (value === 'WaitForSetup') {
      return 'primary';
    } else if (value === 'On') {
      return 'success';
    } else if (value === 'Expired') {
      return 'error';
    } else {
      return 'grey lighten-2';
    }
  };
}
